import { Message } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { useCareContinuityRedirect } from "@unauthenticated/signupSignin/hooks/useCareContinuityRedirect/useCareContinuityRedirect";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

const CareContinuityBanner = () => {
  const { t } = useTranslation();
  const isCareContinuityRedirect = useCareContinuityRedirect();

  if (!isCareContinuityRedirect) return null;

  return <Message intention="neutral" label={t(l.patientRxAuth.careContinuityBanner.text)} />;
};

export { CareContinuityBanner };
